import { createStyles } from 'hooks'

export const useStyles = createStyles(theme => ({
  selectBox: {
    marginRight: '1rem',
  },
}))
